/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavReportColumnMapping } from './DailyNavReportColumnMapping';
import type { DailyNavReportMappingField } from './DailyNavReportMappingField';
export type FirmDailyNavConfigVersion = {
  readonly id?: number;
  firm: number;
  effective_from: string;
  effective_to?: string | null;
  cap_iq_short_window_delta: string;
  cap_iq_long_window_delta: string;
  cap_iq_since_last_valuation_delta: string;
  secondary_short_window_delta: string;
  secondary_long_window_delta: string;
  secondary_since_last_valuation_delta: string;
  secondary_change_from_mark_delta?: string | null;
  notification_recipients?: any;
  report_send_time?: string;
  trading_calendar: FirmDailyNavConfigVersion.trading_calendar;
  reporting_currency?: string;
  short_window_sessions: number;
  long_window_sessions: number;
  report_template?: number | null;
  readonly report_template_filename?: string | null;
  report_column_map: Array<DailyNavReportColumnMapping>;
  readonly report_mapping_fields?: Array<DailyNavReportMappingField>;
  ftp_host?: string | null;
  ftp_port?: number;
  ftp_path?: string | null;
  ftp_username?: string | null;
  readonly created_by_name?: string;
  readonly is_active?: boolean;
  readonly created_at?: string;
};
export namespace FirmDailyNavConfigVersion {
  export enum trading_calendar {
    XNYS = 'XNYS',
    XNAS = 'XNAS',
    XTSE = 'XTSE',
    XLON = 'XLON',
    XETR = 'XETR',
    XPAR = 'XPAR',
    XTKS = 'XTKS',
    XHKG = 'XHKG',
    XASX = 'XASX',
  }
}

